import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the zohoVerify state domain
 */

const selectZohoVerifyDomain = state => state.zohoVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectZohoVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectZohoVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
